module.exports = {
	name: 'Bon lux - Bon lux web app',
	shortName: 'Bon lux',
	description: 'Bon lux portal version of the mobile app',
	primaryColor: '#126049',
	secondaryColor: '#10B388',
	msTileColor: '#0886a5'
}
// rama-pharma
// module.exports = {
// 	name: 'Rama pharma - Rama pharma web app',
// 	shortName: 'Rama pharma',
// 	description: 'Rama pharma portal version of the mobile app',
// 	primaryColor: '#004a98',
// 	secondaryColor: '#f57f20',
// 	msTileColor: '#568cc5'
// }
